const Search = ({ ...props }) => {
    return (
        <svg
            width="20"
            height="20.02"
            viewBox="0 0 20 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g opacity="0.6">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.2886 16.0068C11.903 17.0358 10.1866 17.6446 8.32814 17.6446C3.72864 17.6446 0 13.9159 0 9.31642C0 4.71692 3.72864 0.988281 8.32814 0.988281C12.9276 0.988281 16.6563 4.71692 16.6563 9.31642C16.6563 11.1739 16.0482 12.8893 15.0203 14.2744L20 19.2846L18.2627 21.0114L13.2886 16.0068ZM14.2068 9.31642C14.2068 12.5631 11.5749 15.1951 8.32814 15.1951C5.08143 15.1951 2.44945 12.5631 2.44945 9.31642C2.44945 6.06971 5.08143 3.43773 8.32814 3.43773C11.5749 3.43773 14.2068 6.06971 14.2068 9.31642Z"
                    fill="#fff"
                />
            </g>
        </svg>
    )
}

export default Search
